export const pluraLize = (word, count) => {
  return count > 1 ? `${count} ${word}` : `${count} ${word.replace('s', '')}`;
};
